
























































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import ConfirmButton from '@/components/ConfirmButton.vue';
import AppService from '@/services/apps.service';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';
import InterfaceService from '@/services/interface.service';
import AceEditor from 'vue2-ace-editor';
import 'brace/mode/json';
import 'brace/theme/clouds';


@Component({
  components: {
    ConfirmButton,
    CancelButton,
    GenericButton,
    Dialog,
    AceEditor,
  },
})
export default class AppEdit extends Vue {
  @Prop() private application: any;

  private isSaving: boolean = false;
  private permissionsSelected: any[] = [];
  private permissions: string[] = [ 'administration:manage',
    'application:manage',
    'application:read',
    'daizy:debug',
    'device:manage',
    'device:read',
    'devicetype:manage',
    'devicetype:read',
    'gateway:manage',
    'gateway:read',
    'gatewaytype:read',
    'inventory:manage',
    'inventory:read',
    'network:manage',
    'organisation:manage',
    'organisation:read',
    'project:manage',
    'project:read',
    'publish:manage',
    'publish:read',
    'site:manage',
    'site:read',
    'subscription:manage',
    'subscription:read',
    'task:manage',
    'task:read',
    'user:manage',
    'user:read',
  ];
  private deviceTypes: string[] = [];
  private interfaces: string[] = [];
  private deviceTypesSelected: string[]|null = null;
  private interfacesSelected: string[]|null = null;
  private useInterfaces = true;
  private editorText = { measurements: [] };
  private measurements: any = {};
  private waterhealth = [
    {
      name: 'alerts',
      schema: {
        tags: [
          'projectId',
          'siteId',
          'locationId',
          'channelNumber',
        ],
        fields: {
          time: 'timestamp',
          site: 'string',
          location: 'string',
          deviceId: 'string',
          channelLabel: 'string',
          temperature: 'float',
          alertType: 'string',
          threshold: 'float',
          channelConfig: 'integer',
        },
      },
    },
    {
      name: 'compliance',
      schema: {
        tags: [
          'projectId',
          'siteId',
          'locationId',
          'channelNumber',
        ],
        fields: {
          deviceId: 'string',
          time: 'timestamp',
          site: 'string',
          location: 'string',
          channelLabel: 'string',
          channelConfig: 'integer',
          compliantEventCount: 'integer',
          totalEventCount: 'integer',
          maxTemp: 'float',
          minTemp: 'float',
          ambientTemp: 'float',
        },
      },
    },
  ];

  public async save() {
    this.isSaving = true;
    try {
      const payload: any = {
        name: this.application.name,
        publisher: this.application.publisher,
        description: this.application.description,
        version: this.application.version,
        permissions: this.permissionsSelected,
        measurements: this.measurements && typeof  this.measurements === 'string' ? JSON.parse(this.measurements).measurements : [],
      };
      if (this.useInterfaces) {
        payload.interfaces = this.interfacesSelected;
      } else {
        payload.device_types = this.deviceTypesSelected;
      }

      await AppService.createApplication(payload);

      this.$emit('close');
    } finally {
      this.isSaving = false;
    }
  }

  private updateMeasurements(text: string) {
    if (!text || !text.length) {
      return;
    }
    this.measurements = text;
  }

  private editorInit(editor: any) {
    editor.setOptions({
      fontSize: '1em',
    });
  }

  private async mounted() {
    await Promise.all([this.populateDeviceTypes(), this.populateInterfaces()]);
  }

  private async populateInterfaces() {
    const interfaces = await InterfaceService.getInterfaces();
    this.interfaces = interfaces.map( ( int ) => int.slug );
  }

  private async populateDeviceTypes() {
    const deviceTypes = await AdminDeviceTypeService.getSystemDeviceTypes();
    this.deviceTypes =  deviceTypes.map
    ( (deviceType) => deviceType.slug);
  }

  private async deleteApp(app: { id: string, version: string }) {
    this.isSaving = true;
    try {
      await AppService.destroyApplication(app.id, app.version);
    } finally {
      this.isSaving = false;
      this.$emit('close');
    }

  }
}
